import { DestroyRef, inject, Pipe, type PipeTransform } from '@angular/core';

@Pipe({ name: 'cssUrl' })
export class CssUrlPipe implements PipeTransform {
  private readonly destroyRef = inject(DestroyRef);

  transform(url: string) {
    if (!url) {
      return null;
    }

    return url.startsWith('url(') ? url : `url('${url}')`;
  }
}
